import React, { useEffect, useState, useReducer } from 'react';
import { Link } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from '../../../../../../../_metronic/_helpers';
import { FormattedMessage } from 'react-intl';
import CheckBox from '../../../../../../components/CheckBox';
import axios, { baseUrl } from '../../../../../../../redux/my-axios';

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        items: action.payload.map((item) => {
          const updatedItem = {
            ...item,
            boxed: item.boxed === 1 ? true : false,
          };
          return updatedItem;
        }),
      };
    case 'updateCheck':
      return {
        items: state.items.map((item) => {
          if (item.productCode === action.payload.id) {
            const updatedItem = {
              ...item,
              boxed: action.payload.boxed,
            };
            return updatedItem;
          }
          return item;
        }),
      };
    case 'updatecount':
      return {
        items: state.items.map((item) => {
          if (item.productCode === action.payload.id) {
            let temp = Number(action.payload.newCount);
            let temp2 = parseFloat(
              item.unitPrice
                .toString()
                .replace('$', '')
                .replace(',', '')
            );
            const updatedItem = {
              ...item,
              qty: temp,
              totalPrice:
                Math.round((temp * temp2 + Number.EPSILON) * 100) / 100,
            };

            return updatedItem;
          }

          return item;
        }),
      };
    default:
      throw new Error();
  }
}

const DELIVER_URL = '/deliveries';

export default function Sale(props) {
  const { openDialog, setOpenDialog, updateBoxed, sale, deliverCode } = props;
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [err, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [state, dispatch] = useReducer(reducer, { items: [] });

  function IconColumnFormatter(cellContent, row) {
    const getPic = (pic) => {
      if (pic)
        return `${baseUrl}/product-image-download?id=${row.productCode}&file=${pic}`;
      else return toAbsoluteUrl('/media/logos/logo-gc.png');
    };
    return (
      <div
        style={{
          border: '3',
          width: '100px',
          height: '100px',
          borderRadius: '5%',
        }}
      >
        <img
          className='img-thumbnail'
          style={{ width: '100%', height: '100%' }}
          src={getPic(row.icon)}
        ></img>
      </div>
    );
  }
  function NameColumnFormatter(cellContent, row) {
    return (
      <div
        style={{
          display: 'flex-inline',
          justifyContent: 'left',
          alignItems: 'left',
        }}
      >
        <div style={{ display: 'flex' }}>
          <span style={{ fontStyle: 'bold', fontSize: 'medium' }}>
            {row.brandName}
          </span>
        </div>
        <div>
          <span style={{ fontStyle: 'bold', fontSize: 'large' }}>
            {cellContent}
          </span>
        </div>
        <div
          style={{
            fontStyle: 'italic',
            fontSize: 'small',
          }}
        >
          {row.productCode}
        </div>
      </div>
    );
  }
  function PriceColumnFormatter(cellContent, row) {
    return (
      <div
        style={{
          display: 'flex-block',
          justifyContent: 'right',
          alignItems: 'right',
        }}
      >
        <div style={{ display: 'block' }}>
          <span style={{ fontStyle: 'bold', fontSize: 'medium' }}>
            {cellContent
              ? cellContent
                  .toString()
                  .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
              : '0.00'}
          </span>{' '}
        </div>
        {cellContent !== row.price && (
          <div>
            <span style={{ fontStyle: 'bold', fontSize: 'small' }}>
              {row.price
                ? row.price
                    .toString()
                    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                : '0.00'}
            </span>
          </div>
        )}
      </div>
    );
  }
  function QtyColumnFormatter(cellContent, row) {
    return (
      <div
        style={{
          display: 'flex-block',
          justifyContent: 'right',
          alignItems: 'right',
        }}
      >
        <div style={{ display: 'block' }}>
          <span style={{ fontStyle: 'bold', fontSize: 'large' }}>
            {cellContent}
          </span>
        </div>
      </div>
    );
  }
  function CheckColumnFormatter(cellContent, row) {
    return (
      <div
        style={{
          justifyContent: 'center',
          alignItems: 'top',
          textAlign: 'center',
        }}
      >
        {' '}
        <CheckBox
          name='boxed'
          className='form-control form-control-sm'
          text=''
          checked={cellContent}
          changeCheckBoxValue={(e) => {
            onHandleCheck(row, e);
          }}
        />
      </div>
    );
  }

  const columns = [
    {
      dataField: 'icon',
      text: '',
      sort: false,
      style: {
        width: '65px',
      },
      formatter: IconColumnFormatter,
    },
    {
      dataField: 'name',
      text: 'Бүтээгдэхүүн',
      sort: false,
      formatter: NameColumnFormatter,
    },
    {
      dataField: 'unitPrice',
      text: 'Үнэ',
      sort: false,
      classes: 'text-right pr-1',
      formatter: PriceColumnFormatter,
      style: {
        minWidth: '90px',
        width: '90px',
      },
    },
    {
      dataField: 'qty',
      text: 'Тоо',
      sort: false,
      formatter: QtyColumnFormatter,
      classes: 'text-right',
      style: {
        minWidth: '30px',
        width: '50px',
      },
    },
    {
      dataField: 'boxed',
      text: 'Бэлдсэн',
      formatter: CheckColumnFormatter,
      classes: 'text-center',
      style: {
        width: '50px',
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    axios
      .post(
        DELIVER_URL,
        { deliverCode, saleCode: sale.saleCode },
        {
          headers: { action: 'getsaleitems' },
        }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('getsaleitems: ', response.data.data);
            setTotalCount(response.data.data.length);
            dispatch({ type: 'init', payload: response.data.data });
            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [openDialog]);

  useEffect(() => {
    updateBoxed({ saleCode: sale.saleCode, items: state.items });
  }, [state]);
  const onHandleCheck = (row, boxed) => {
    console.log('Boxed', row);
    setLoading(true);
    axios
      .post(
        DELIVER_URL,
        {
          deliverCode: deliverCode,
          saleCode: sale.saleCode,
          productCode: row.productCode,
          boxed: boxed === true ? 1 : 0,
        },
        { headers: { action: 'setsaleitem' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('set items: ', response.data.data);
            setError('');
            setMsg(response.data.data);
            setLoading(false);
            dispatch({
              type: 'updateCheck',
              payload: { id: row.productCode, boxed: boxed },
            });

            break;
          default:
            var error = response.data.msg.desc;
            setMsg('');
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setMsg('');
        setError(error);
        setLoading(false);
      });
  };

  const done = () => {
    setOpenDialog(false);
  };
  return (
    <Modal
      size='lg'
      show={openDialog}
      onHide={() => setOpenDialog(false)}
      backdrop='static'
      keyboard={false}
      aria-labelledby='example-modal-sizes-title-lg'
    >
      <Modal.Header>
        <Modal.Title id='confirm-dialog'>
          Худалдан авагч: {sale.fbName} <br />
          Утас: {sale.mobile}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Container>
          <div>
            {err ? (
              <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
                <div className='alert-text font-weight-bold'>{err}</div>
              </div>
            ) : (
              <div></div>
            )}
            {msg ? (
              <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
                <div className='alert-text font-weight-bold'>{msg}</div>
              </div>
            ) : (
              <div></div>
            )}
            {/*  {openSelectProducts && (
              <SelectedProduct
                openSelectProducts={openSelectProducts}
                setOpenSelectProducts={setOpenSelectProducts}
                addSelectedItems={addSelectedItems}
                //existingItems={entities}
                existingItems={state.items}
              />
            )}
            {toRemoveItem && (
              <DialogBox
                openDialog={openConfirmRemoveItem}
                setOpenDialog={setOpenConfirmRemoveItem}
                icon='question'
                iconColor='danger'
                title='Худалдан авалтын сонголтоос бараа хасах'
                text={`${toRemoveItem.name} #${toRemoveItem.productCode}  гэсэн сонгосон барааг устгахдаа итгэлтэй байна уу?'`}
                buttonOk={false}
                buttonYes={true}
                buttonNo={true}
                onConfirm={remove}
              ></DialogBox>
            )} */}

            <BootstrapTable
              wrapperClasses='table-responsive'
              classes='table table-head-custom table-vertical-center overflow-hidden'
              bootstrap4
              bordered={true}
              local
              keyField='productCode'
              //data={entities === null ? [] : entities}
              data={state.items === null ? [] : state.items}
              columns={columns}
              //onTableChange={getHandlerTableChange(setQueryParams)}
              /*  selectRow={getSelectRow({
          entities,
          ids,
          setIds,
        })} */
            >
              {/*  <PleaseWaitMessage entities={entities} />
        <NoRecordsFoundMessage entities={entities} /> */}
              <PleaseWaitMessage entities={state.items} />
              <NoRecordsFoundMessage entities={state.items} />
            </BootstrapTable>
          </div>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button
          id='dialogYes'
          variant='info'
          onClick={() => {
            setOpenDialog(false);
            done();
          }}
        >
          <FormattedMessage id='DELIVERIES.BUTTON.COMPLETE' />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
